import React, { type FunctionComponent } from 'react'
import { schemeMap } from '../../common/charity'
import { useSearchParams } from 'react-router-dom'
import { Button } from '@tomra/design-system-react/button'

type Props = {
  style: 'select' | 'button'
  onSelected: (filter: CharityFilterType) => void
}

export const SelectAppContext: FunctionComponent<Props> = ({ style, onSelected }) => {
  const [searchParams] = useSearchParams()

  const availableSchemes = Object.keys(schemeMap)

  function paramsToArray(params: string | null): string[] {
    return params?.split(',') || []
  }

  if (style === 'button') {
    return (
      <div className="flex gap-md">
        {availableSchemes.map(key => (
          <Button
            key={`btn-${key}`}
            onClick={() => {
              onSelected({
                appContext: key as CharityAppContext
              })
            }}
          >
            {schemeMap[key]}
          </Button>
        ))}
      </div>
    )
  }

  return (
    <div>
      <label htmlFor="appContext" className="label">
        App
      </label>
      <select
        id="appContext"
        defaultValue={searchParams.get('appContext') || ''}
        onChange={({ target }) => {
          onSelected({
            appContext: target.value as CharityAppContext,
            name: searchParams.get('name') || '',
            status: paramsToArray(searchParams.get('status')) as CharityStatusType[],
            campaignStatus: paramsToArray(searchParams.get('campaignStatus')) as CampaignStatusType[],
            startTime: searchParams.get('startTime') || ''
          })
        }}
        className="border border-gray-300 rounded px-3 py-2 bg-white w-full focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent"
      >
        <option value="" disabled>
          Switch app
        </option>
        {availableSchemes.map(key => (
          <option key={`btn-${key}`} value={key}>
            {schemeMap[key]}
          </option>
        ))}
      </select>
    </div>
  )
}
